import _ from 'underscore';

import BaseAppState from '../../utils/statemachine/BaseAppState';

import GameSounds from '../../sound/GameSounds';
import GameScreen from '../../display/GameScreen';

/////////////////////////////////////////////////////////////////////////
// GameStartState //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GameStartState = _.extend( Object.create(BaseAppState), {

  setup: function(game) {

    this.init(game, 'GameStartState');

    // props
    this.firstRun = true;

    // listeners
    this.game.logic.onSignalTurnReady.add(this.handleGameReady, this);

    // signals
		this.onSignalGamePlayStart = new Phaser.Signal();

    // buttons
    this.game.display.splashScreen.playButton.events.onInputUp.add(this.handlePlayButtonPressed, this);

    return this;
  },

	onEnter: function() {
		
		this._onEnter(this);

		// start music
		this.game.soundManager.playMusicLoop(GameSounds.MUSIC_LOOP);
    //this.game.soundManager.mute();  // temp

		// show splash - may not do this if not the 1st game of the session
    if (this.firstRun) {
      this.game.display.splashScreen.show();
    }


		// could be a place to show tutorials, preloaders, etc.
		// TODO

    // start new game
    this.game.logic.startGame();

    // would like to handle the 'TurnReady' Signal here, but can't due to memorize bug
	},

	update: function() {
	
		this._update();
		
	},

	onExit: function() {
		
		this._onExit();

    // back to black
    this.game.stage.backgroundColor = 0x00000;

    // hide splash
    this.game.display.splashScreen.hide();

    // show main screen
    this.game.display.gameScreen.visible = true;

    // no longer first run
    this.firstRun = false;
	},


  handleGameReady: function(balls, error) {

    if (!this.isActive)
      return;

    // do error checking



    if (this.firstRun && !GameScreen.USE_3D) {
      // show start button on 1st game
      this.game.display.splashScreen.showPlayButton();
    }
    else {
      // go straight to the game
      this.onSignalGamePlayStart.dispatch();
    }

  },

  handlePlayButtonPressed: function() {

		// Might be needed on mobile devices to give game 'focus'
		/*
		*/

    // start the game
		this.onSignalGamePlayStart.dispatch();
	},

	/////////////////////////////////////////////////////////////////////////
	// SIGNAL HANDLERS //////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////


	/////////////////////////////////////////////////////////////////////////
	// HELPERS ////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////



});

export default GameStartState;




// WEBPACK FOOTER //
// ./app/src/states/game/GameStartState.js